import { platform, getDevicePlatform } from 'platformImpl'
import { getOnToken } from 'platformImpl';

const NAME_LOCAL_STORAGE = 'notificationToken';

export const getNotificationToken = () => {
    if (platform.isCordova) {
        return localStorage.getItem(NAME_LOCAL_STORAGE);
    }

    return null;
}

export const removeNotificationToken = () => {
    if (platform.isCordova) {
        localStorage.removeItem(NAME_LOCAL_STORAGE);
    }
}

export async function onSaveNotificationToken() {
    if (platform.isCordova) {
        let token = await getOnToken();
        localStorage.setItem(NAME_LOCAL_STORAGE, token);
        return token;
    }
    return null;
}

export const getPlataforma = () => {
    const p = getDevicePlatform();    
    let plataforma = Object.assign({});

    if (p === 'Android') {
        plataforma.id = 1;
        plataforma.nome = p;
    }

    if (p === 'iOS') {
        plataforma.id = 2;
        plataforma.nome = p;
    }

    if (plataforma.nome === undefined) {
        plataforma = { id: 3, nome: 'Outros' };
    }    
    return plataforma;
}
